<template>
  <div>
    <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.first_access_label')}}</p>
    <el-form
      @submit.prevent.native="doLogin('firstLoginForm')"
      class="px-4 sm:px-0"
      :model="firstLoginForm"
      :rules="firstLoginFormRules"
      ref="firstLoginForm"
      novalidate
    >
      <div>
        <el-form-item  prop="oldPassword">
          <el-input
            :placeholder="$t('configurations.old_password')"
            type="password"
            class="mb-2 custom__icons static-css"
            show-password
            clearable
            v-model="firstLoginForm.oldPassword"
            maxlength='50'
          >
            <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm" name="lock" />
            </i>
          </el-input>
        </el-form-item>
      </div>
      <base-password-form-item v-model="firstLoginForm.newPassword" name="newPassword" :placeholder="$t('noauth.new_password')" />
      <base-password-form-item v-model="firstLoginForm.repeatPassword" :password="firstLoginForm.newPassword" name="repeatPassword" :placeholder="$t('noauth.confirm_password')" repeat />
      <base-button
        class="w-full"
        mode="staticprimary"
        text="Acceder"
        type="submit"
        :loading = "loader"
      />
    </el-form>
  </div>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  name: 'first-login-form',
  data: function () {
    return {
      loader: false,
      firstLoginForm: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
      },
      firstLoginFormRules: {
        oldPassword: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
      }
    }
  },
  methods: {
    doLogin: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            const payload = {
              oldPassword: this.firstLoginForm.oldPassword,
              password: this.firstLoginForm.newPassword,
            }
            await this.$store.dispatch('auth/firstLoginPassword', payload)
            await this.$store.dispatch('app/getAnnouncementsList')
          } catch (error) {
            if (error !== undefined && error.blnError) {
              if (error.stepCode === 2) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTPConfig')
              } else if (error.stepCode === 3) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTP')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', error))
              }
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    isNewPasswordValid: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validation.general = false
        this.validation.numChar = false
        this.validation.numMin = false
        this.validation.charMinus = false
        this.validation.charMayus = false
        return callback(new Error(i18n.t('validation.complete')))
      } else {
        if (!re.test(value)) {
          this.validation.general = false
        } else {
          this.validation.general = true
        }
        if (value.length < 8) {
          this.validation.numChar = false
        } else {
          this.validation.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validation.numMin = false
        } else {
          this.validation.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validation.charMinus = false
        } else {
          this.validation.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validation.charMayus = false
        } else {
          this.validation.charMayus = true
        }
        if (!reMin.test(value) || value.length < 8 || !reNumber.test(value) || !reMinus.test(value) || !reMayus.test(value)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    isRepeatPasswordValid: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validationRepeat.general = false
        this.validationRepeat.numChar = false
        this.validationRepeat.numMin = false
        this.validationRepeat.charMinus = false
        this.validationRepeat.charMayus = false
        this.validationRepeat.passRepeat = false
        return callback(new Error(i18n.t('validation.complete')))
      } else {
        if (!re.test(value)) {
          this.validationRepeat.general = false
        } else {
          this.validationRepeat.general = true
        }
        if (value.length < 8) {
          this.validationRepeat.numChar = false
        } else {
          this.validationRepeat.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validationRepeat.numMin = false
        } else {
          this.validationRepeat.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validationRepeat.charMinus = false
        } else {
          this.validationRepeat.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validationRepeat.charMayus = false
        } else {
          this.validationRepeat.charMayus = true
        }
        if (value !== this.firstLoginForm.newPassword) {
          this.validationRepeat.passRepeat = false
        } else {
          this.validationRepeat.passRepeat = true
        }
        if (!reMin.test(value) || value.length < 8 || !reNumber.test(value) || !reMinus.test(value) || !reMayus.test(value)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
        if (value !== this.firstLoginForm.newPassword) {
          return callback(new Error(i18n.t('validation.pass.pass_repeat')))
        }
      }
      callback()
    },
  }
}
</script>

<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
